import BeachAccessIcon from "@mui/icons-material/BeachAccess"
import { Chip } from "@mui/material"
import React from "react"
import { makeStyles } from  "tss-react/mui-compat"

const useStyles = makeStyles()({
  disabledChip: {
    height: "36px",
    width: "99px",
    borderRadius: "20px",
    backgroundColor: "rgba(0,75,160,0.7)",
  },
})

const DisabledChip = () => {
  const { classes } = useStyles()

  return (
    <Chip
      className={classes.disabledChip}
      icon={<BeachAccessIcon />}
      label="Inactive"
      color="primary"
    />
  )
}

export default DisabledChip
